import { ru } from './ru';

/**
 * Словарь текущего языка.
 *
 * Пока язык один, `t` — это просто объект: `t.notFound.title`. Обращение через
 * объект, а не через функцию с ключом-строкой, даёт проверку ключей на этапе
 * сборки: опечатка в ключе — ошибка типов, а не пустая строка на экране.
 */
export const t = ru;
